import { render, staticRenderFns } from "./RendicionNew.vue?vue&type=template&id=384cb7e0&scoped=true&"
import script from "./RendicionNew.vue?vue&type=script&lang=js&"
export * from "./RendicionNew.vue?vue&type=script&lang=js&"
import style0 from "./RendicionNew.vue?vue&type=style&index=0&id=384cb7e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384cb7e0",
  null
  
)

export default component.exports